import Stack from '@mui/material/Stack';
import CallButton from './CallButton';
import SmsButton from './SmsButton';  
import CallNumberDialog from '../modals/CallNumberDialog';
import MessageNumberDialog from '../modals/MessageNumberDialog';

export default function CallSmsButtonCombo({ phoneNumber, bodyText = '' }) {
  return (
    <Stack 
      direction="row" 
      spacing={1}
      sx={{ mb: 2 }}   // adds bottom margin
    >
      <CallNumberDialog phoneNumber={phoneNumber} />
      <MessageNumberDialog phoneNumber={phoneNumber} bodyText={bodyText} />
    </Stack>
  );
}
